var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonApi = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M13.451 22.05a1.989 1.989 0 00-2.812 0l-1.936 1.936c-4.194 4.218-4.185 11.035.022 15.244 4.21 4.187 11.01 4.187 15.222 0l1.936-1.936a1.989 1.989 0 000-2.812L13.452 22.05z", fill: fills.light }),
        React.createElement("path", { d: "M10.933 39.277l-4.254 4.254a1.57 1.57 0 01-2.22-2.22l4.254-4.254 2.22 2.22z", fill: fills.light }),
        React.createElement("path", { d: "M22.06 13.441a1.989 1.989 0 010-2.812l1.936-1.936c4.218-4.194 11.035-4.185 15.244.022 4.187 4.21 4.187 11.01 0 15.222l-1.936 1.936a1.989 1.989 0 01-2.812 0L22.06 13.441z", fill: fills.dark }),
        React.createElement("path", { d: "M25.961 15.486l-4.253 4.254a1.57 1.57 0 01-2.22-2.22l4.253-4.254 2.22 2.22zM39.287 10.923l4.254-4.254a1.57 1.57 0 00-2.22-2.22l-4.254 4.254 2.22 2.22zM34.629 24.157l-4.253 4.253a1.57 1.57 0 01-2.22-2.22l4.253-4.253 2.22 2.22z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
